import { createSlice } from '@reduxjs/toolkit';

const userReportsTabSlice = createSlice({
  name: 'userReports',
  initialState: {
    activeTab: 'Zgłoszeni użytkownicy',
    currentPage: 1,
    maxPages: 1,
    rows: [],
    needRefresh: 1,
  },
  reducers: {
    setPageUserReports(state, action) {
      state.currentPage = action.payload;
    },
    setMaxPagesUserReports(state, action) {
      state.maxPages = action.payload;
    },
    setRowsUserReports(state, action) {
      state.rows = action.payload;
    },
    toggleNeedRefreshUserReports(state) {
      state.needRefresh = state.needRefresh === 1 ? 0 : 1;
    },
  },
});

export const {
  setPageUserReports,
  setMaxPagesUserReports,
  setRowsUserReports,
  toggleNeedRefreshUserReports,
} = userReportsTabSlice.actions;

export default userReportsTabSlice.reducer;
